import { useRef } from "react";

/**
 * Saisie d'un code à 6 chiffres avec auto-focus et support du collé-coller.
 * Props:
 *   value   : string de 0 à 6 chiffres
 *   onChange: (newValue: string) => void
 */
export default function CodeInput({ value, onChange }) {
  const inputs = useRef([]);

  const handleChange = (idx, e) => {
    const digit = e.target.value.replace(/\D/g, "").slice(-1);
    const arr = value.split("");
    arr[idx] = digit;
    onChange(arr.join(""));
    if (digit && idx < 5) inputs.current[idx + 1]?.focus();
  };

  const handleKeyDown = (idx, e) => {
    if (e.key === "Backspace" && !value[idx] && idx > 0) {
      inputs.current[idx - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (pasted.length === 6) {
      onChange(pasted);
      inputs.current[5]?.focus();
    }
    e.preventDefault();
  };

  return (
    <div className="flex justify-center gap-2 my-4" onPaste={handlePaste}>
      {Array.from({ length: 6 }).map((_, idx) => (
        <input
          key={idx}
          ref={(el) => (inputs.current[idx] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={value[idx] || ""}
          onChange={(e) => handleChange(idx, e)}
          onKeyDown={(e) => handleKeyDown(idx, e)}
          className="w-11 h-14 text-center text-2xl font-bold border-2 border-gray-200
                     rounded-lg focus:border-orange-400 focus:outline-none focus:ring-0
                     bg-gray-50 transition-colors"
        />
      ))}
    </div>
  );
}
